import React from 'react';
import { Spin, Alert } from 'antd';
import {
  FaFileAlt,
  FaCheckCircle,
  FaFolder,
  FaList,
  FaDollarSign,
  FaMoneyBillWave,
  FaExclamationTriangle
} from 'react-icons/fa';
import * as MoneyFormater from '../../../../utils/MoneyFormater';
import './styles.css';

const PastaResumo = ({ estatisticas, loading, error }) => {
  if (loading) {
    return (
      <div className="pasta-resumo__loading">
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <Alert
        message="Erro ao carregar resumo"
        description={error}
        type="error"
        showIcon
        className="pasta-resumo__error"
      />
    );
  }

  if (!estatisticas) {
    return null;
  }

  const cards = [
    {
      icon: <FaFileAlt />,
      label: 'Total de Acordos',
      value: estatisticas.total_acordos || 0,
      type: 'info'
    },
    {
      icon: <FaCheckCircle />,
      label: 'Acordos Ativos',
      value: estatisticas.acordos_ativos || 0,
      type: 'success'
    },
    {
      icon: <FaFolder />,
      label: 'Contratos (TXT)',
      value: estatisticas.total_contratos || 0,
      type: 'info'
    },
    {
      icon: <FaList />,
      label: 'Total Parcelas',
      value: estatisticas.total_parcelas || 0,
      type: 'info'
    },
    {
      icon: <FaDollarSign />,
      label: 'Valor Total Acordos',
      value: estatisticas.valor_total_acordos !== null
        ? `R$ ${MoneyFormater.format(estatisticas.valor_total_acordos)}`
        : 'Restrito',
      type: 'highlight',
      isRestricted: estatisticas.valor_total_acordos === null
    },
    {
      icon: <FaMoneyBillWave />,
      label: 'Valor Pago',
      value: estatisticas.valor_pago !== null
        ? `R$ ${MoneyFormater.format(estatisticas.valor_pago)}`
        : 'Restrito',
      type: 'success',
      isRestricted: estatisticas.valor_pago === null
    },
    {
      icon: <FaExclamationTriangle />,
      label: 'Valor Pendente',
      value: estatisticas.valor_pendente !== null
        ? `R$ ${MoneyFormater.format(estatisticas.valor_pendente)}`
        : 'Restrito',
      type: 'warning',
      isRestricted: estatisticas.valor_pendente === null
    }
  ];

  return (
    <div className="pasta-resumo__container">
      <h3 className="pasta-resumo__title">Resumo Geral da Pasta</h3>
      <div className="pasta-resumo__grid">
        {cards.map((card, index) => (
          <div
            key={index}
            className={`pasta-resumo__card pasta-resumo__card--${card.type} ${
              card.isRestricted ? 'pasta-resumo__card--restricted' : ''
            }`}
          >
            <div className={`pasta-resumo__icon pasta-resumo__icon--${card.type}`}>
              {card.icon}
            </div>
            <div className="pasta-resumo__content">
              <div className="pasta-resumo__label">{card.label}</div>
              <div className="pasta-resumo__value">{card.value}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PastaResumo;



// WEBPACK FOOTER //
// ./src/pages/Pasta/components/PastaResumo/index.jsx